export default "__VITE_ASSET__04416d88__"